import React, { useEffect, useMemo, useState } from "react";
import Fuse from "fuse.js";
import { getLessons, getSearchIndex } from "../api";
import LessonSections from "../components/LessonSections";

const FUSE_OPTIONS = {
  keys: ["topic", "summary"],
  threshold: 0.35,
};

export default function Search() {
  const [index, setIndex] = useState([]);
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState("");
  const [loadingDetail, setLoadingDetail] = useState(false);

  useEffect(() => {
    getSearchIndex()
      .then((data) => setIndex(data.index))
      .catch((err) => setError(err.message));
  }, []);

  const fuse = useMemo(() => new Fuse(index, FUSE_OPTIONS), [index]);

  const results = useMemo(() => {
    if (!query.trim()) return index;
    return fuse.search(query).map((r) => r.item);
  }, [query, fuse, index]);

  async function openLesson(entry) {
    setLoadingDetail(true);
    setError("");
    try {
      const data = await getLessons({ date: entry.date });
      setSelected(data.lessons[0]);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingDetail(false);
    }
  }

  if (selected) {
    return (
      <div className="page">
        <button className="back-link" onClick={() => setSelected(null)}>
          &larr; Back to search
        </button>
        <LessonSections lesson={selected} />
      </div>
    );
  }

  return (
    <div className="page">
      <h1>Search</h1>
      <input
        className="search-input"
        type="search"
        placeholder="Search lessons by topic..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {error && <p className="error">{error}</p>}
      {loadingDetail && <p>Loading lesson...</p>}

      <ul className="archive-list">
        {results.map((entry) => (
          <li key={entry.date} className="archive-item" onClick={() => openLesson(entry)}>
            <p className="archive-date">{entry.date}</p>
            <h3>{entry.topic}</h3>
            <p className="archive-summary">{entry.summary}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
